import { AxiosInstance } from "axios";
import { apiTypeUrlBaseGet } from "../api_common";
import { API_APP_NAMES, API_TYPES } from "../api_constants";
import { authorizationObDefault, axiosInstanceCreate } from "./axios_common";
import { axiosInstance401Handle } from "./axios_intercepter_common";

const sakusasUrlBase: string = apiTypeUrlBaseGet(API_TYPES.SAKUSAS);

const sakusasAuth = authorizationObDefault();

const API_SAKUSAS_RETRY_LIMIT: number = 3;

export const axiosSakusas: AxiosInstance = axiosInstanceCreate(sakusasUrlBase);

axiosSakusas.interceptors.response.use(null, async (err) => {
  if (typeof err.config.retryLimit === "undefined") {
    err.config.retryLimit = API_SAKUSAS_RETRY_LIMIT;
  }
  if (err.config.retryLimit === 0) {
    throw err;
  }
  err.config.retryLimit--;
  if (err.response.status === 401 && err.config.retryLimit > 0) {
    try {
      await axiosInstance401Handle(
        axiosSakusas,
        API_APP_NAMES.SAKUSAS,
        sakusasAuth
      );
    } catch (err) {
      throw err;
    }
  }
  const response = await axiosSakusas(err.config);
  return response;
});
